import React, { useCallback, useEffect, useState } from "react";
import { Box, Stack, Typography, Card, Button } from "@mui/material";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Iconify from "src/components/iconify/Iconify";
import Image from "src/components/image/Image";
import { fetchImage } from "src/utils/fetchImage";
import { useRestaurantOpenClose } from "src/utils/useRestaurantOpenClose";
import { StarIcon } from "src/theme/overrides/CustomIcons";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSnackbar } from "src/components/snackbar";
import axios from "axios";
dayjs.extend(utc);

const NewVenueCard = ({ item, selectedTableSize, tempTableSize, selectedDate, selectedTime }) => {
  const [venuesDataImage, setVenuesDataImage] = useState([]);
  const { isLoggedIn } = useSelector((state) => state.login);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  console.log(item.slots)

  const getImages = useCallback(async () => {
    try {
      const res = await fetchImage(item?.photoURL);
      setVenuesDataImage(res);
    } catch (error) {
      console.error("Error fetching Images:", error);
    }
  }, [venuesDataImage, item]);
  useEffect(() => {
    getImages();
  }, [item]);

  const { currentDay, formatTime, venueStatus } = useRestaurantOpenClose();

  useEffect(() => {
    if (item && item.venueTimings && item.venueTimings[currentDay]) {
      const currentTime = item?.venueTimings[currentDay];
      if (currentTime) {
        formatTime(currentTime, item);
      }
    }
  }, [item, currentDay]);

  let { configurations } = item ?? {};
  let { isPromotionAvailable } = configurations ?? {};



  const renderStar = (rating) => {
    return (
      <StarIcon
        style={{
          color: rating > 0 ? "#fca92e" : "#ccc",
          fontSize: "16px",
        }}
      />
    );
  };
  const isReservation = localStorage.getItem('isReservation')

  const formatTimeIn = (isoString) => {
    if (!isoString) return '';
    const utcTime = dayjs(isoString).utc(); // convert to UTC
    const hour = utcTime.hour();
    const minute = utcTime.minute().toString().padStart(2, '0');
    const ampm = hour < 12 ? "am" : "pm";
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };

  const handleSlotClick = async (res) => {
    const currentDateTime = dayjs();
    const selectedDay = dayjs(selectedDate);
    const today = dayjs().format('YYYY-MM-DD');
    const selectedDateFormatted = selectedDay.format('YYYY-MM-DD');
    const rawTime = res?.startingTime.replace('Z', '');
    const slotDateTime = dayjs(rawTime);
    if (selectedDateFormatted === today && currentDateTime.isAfter(slotDateTime)) {
      enqueueSnackbar('Slot time has already passed!', { variant: 'error' });
      return;
    }

    console.log({ res })
    const payload = {
      date: selectedDay.format('YYYY-MM-DD'),
      startTime: res?.startingTime,
      endTime: res.endingTime,
      partySize: tempTableSize.toString(),
      venueId: res?.venueId,
      levelId: res?.levelId,
      tableId: res?.tableId,
      areaId: res?.areaId?.id,
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/reservation/bookSlotTemporary`,
        payload
      );

      const destination = isLoggedIn
        ? `/venue/${item.id}`
        : '/auth/login?type=reservation';

      navigate(destination, {
        state: {
          isReservation: {
            selectedTableSize: tempTableSize,
            selectedDate,
            selectedTime,
            selectedSlot: res,
            confirmationPage: true,
          },
        },
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
    }
  };

  return (

    <Box
      sx={{
        width: "100%",
        mt: 0.5,
        mb: 4,
      }}
    >
      <Card
        sx={{
          backgroundColor: "rgb(255, 255, 255)",
          boxShadow: "rgba(112, 132, 153, 0.2) 0px 0px 2px 0px, rgba(67, 69, 71, 0.12) 0px 12px 24px -4px",
        }}>
        <Box
          sx={{
            borderRadius: "10px",

            boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
        >
          <Link
            to={`/venue/${item?.id}`}
            state={{
              isReservation: {
                selectedTableSize,
                selectedDate,
                selectedTime,
                confirmationPage: false
              }
            }}
            style={{ textDecoration: "none", color: "#FCA92E" }}
          >
            <Box
              sx={{
                position: "relative",
              }}
            >
              {isPromotionAvailable && (
                <>
                  {item?.promotions?.slice(0, 2).map((elem, index) => (
                    <Typography
                      key={index}
                      sx={{
                        fontWeight: "bold",
                        position: "absolute",
                        right: 0,
                        top: `${index * 30}px`,
                        background: "#FCA92E",
                        zIndex: 1,
                        padding: "5px 10px",
                        borderRadius: "5px",
                        color: "black",
                        fontSize: "12px",
                      }}
                    >
                      {elem?.tag}
                    </Typography>
                  ))}
                </>
              )}
              <Stack
                sx={{
                  width: "100%",
                  height: "130px",
                  padding: "8px",
                  "@media (max-width: 1440px)": {
                    height: "120px",
                  },
                }}
              >
                <Image
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                  src={
                    venuesDataImage ? venuesDataImage : "/assets/placeholder.png"
                  }
                  alt="Venue Images"
                />
              </Stack>
            </Box>

            <Stack>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "700",
                  marginRight: "10px",
                  marginLeft: "10px",
                  marginTop: "5px",
                }}
              >
                <Link
                  to={`/venue/${item.id}`}
                  state={{
                    isReservation: {
                      selectedTableSize,
                      selectedDate,
                      selectedTime,
                      confirmationPage: false
                    }
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#F59B34",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    maxWidth: "calc(100% - 80px)",
                  }}
                >
                  {item.name}
                </Link>

                <Typography
                  sx={{ color: "gray", fontSize: "14px" }}
                  component="span"
                >
                  {(Number(item?.distance) / 1000).toFixed(1)} km
                </Typography>
              </Typography>


              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginRight: "10px"
                }}
              >
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "12px",
                    marginTop: "3px",
                    color: "#212B36",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Iconify
                    sx={{
                      height: 20,
                      width: 30,
                    }}
                    icon="ion:location-outline"
                    color="#fca92e"
                  />
                  <span
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                      maxWidth: "calc(100% - 40px)",
                    }}
                  >
                    {item.venueAddressOne}
                  </span>
                </Typography>
                {(isReservation === 'true' && item?.reservationAdvanceAmount?.type) && <Typography
                  style={{
                    fontSize: "12px",
                    color: "#212B36",
                    whiteSpace: "nowrap",
                  }}
                >
                  Rs.{item?.reservationAdvanceAmount?.amount}{" "}
                  {item?.reservationAdvanceAmount?.type === "perPerson" ? "PP" : "Fixed"}
                </Typography>}
              </Box>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: "12px",
                  marginRight: "10px",
                  marginLeft: "10px",
                  marginTop: "1px",
                  marginBottom: isReservation == 'true' ? "0px" : "8px",
                  color: "#212B36",
                }}
              >
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: ["Closed", "Temporarily Closed"].includes(
                        venueStatus?.statusMessage
                      )
                        ? "red"
                        : "green",
                    }}
                    component="span"
                  >
                    {venueStatus?.statusMessage}
                  </Typography>
                  {(venueStatus?.additionalInfo == "Open at" ||
                    venueStatus?.additionalInfo == "Closes at") && (
                      <span style={{ padding: "0px 5px" }}>-</span>
                    )}
                  <Typography
                    sx={{ fontSize: "12px", marginRight: "5px" }}
                    component="span"
                  >
                    {venueStatus?.additionalInfo}
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }} component="span">
                    {venueStatus?.time}
                  </Typography>
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "4px" }}>
                  <Box sx={{ marginTop: "4px" }}>{renderStar(item?.rating)}</Box>
                  <Box> {item?.rating?.toFixed(1)}</Box>
                </Box>
              </Typography>
            </Stack>
          </Link>
          {isReservation === 'true' && (
            <Box display="flex" flexWrap="nowrap" overflow="auto" padding="5px" gap={1}>
              {Array.isArray(item?.slots) && item.slots.filter(Boolean).slice(0, 3).map((res, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  fullWidth
                  onClick={() => handleSlotClick(res)}
                  sx={{
                    borderColor: "#EF8322",
                    textAlign: "center",
                    borderRadius: "10px",
                    color: "white",
                    backgroundColor: '#F59B34',
                    fontSize: "10px",
                    height: "40px",
                    "&:hover": {
                      backgroundColor: 'white',
                      color: "#FF9800",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      fontSize: "12px",
                      fontWeight: "600",
                      textTransform: "lowercase",
                    }}
                  >
                    {formatTimeIn(res?.startingTime)}
                  </Typography>
                </Button>
              ))}

              {Array.from({ length: 3 - (item?.slots?.length || 0) }).map((_, idx) => (
                <Box key={`empty-${idx}`} flex={1} />
              ))}
            </Box>
          )}
        </Box>
      </Card>
    </Box >
  );
};

export default NewVenueCard;
